( function () {
    // Render Function
    var render = function ( settings, callback ) {

        // Polyfill
        const userAgent = navigator.userAgent;
        var isInternetExplorer = !!( userAgent.indexOf( "Trident/7.0" ) >= 0 );

        if ( isInternetExplorer ) {
            var babelScript = document.createElement( "script" )
            babelScript.type = "text/javascript";
            babelScript.src = settings.baseUrl + '/Content/babel-polyfill.min.js';
            document.body.appendChild( babelScript );
            babelScript.onload = function () {
                loadFiles()
            };
            return;
        }
        loadFiles();

        function loadFiles() {
            // Link in Header
            var link = document.createElement( 'link' );
            link.id = settings.el + '-css';
            link.rel = 'stylesheet';
            link.href = settings.baseUrl + '/Content/totalkredit-beregner.min.css';
            document.head.appendChild( link );

            // Script in Body
            var script = document.createElement( 'script' );
            script.id = settings.el + '-js';
            script.src = settings.baseUrl + '/Content/totalkredit-embedding.min.js';
            // Create promise
            document.body.insertBefore( script, document.body.firstChild )
            script.onload = function () {
                if ( callback != null ) {
                    callback( window.tkcalc.run, settings )
                }
                else {
                    window.tkcalc.run( settings );
                }
            }
        }
    }

    // Settings
    var calculatorId = document.currentScript.getAttribute( 'data-calc-id' ) || null;
    var calculatorName = document.currentScript.getAttribute( 'data-calc-name' ) || null;
    var settings = {
        baseUrl: "https://www.totalkredit.dk",
        el: calculatorId,
        name: calculatorName,
        labels: {},
        csslink: '',
        debugLabels: null
    }
    
    if ( calculatorName !== null ) {
        render( settings, null )
    }
    else {
        console.warn( 'Not loading tk calculator. calculatorName is null.' )
    }
} )()

